import CryptoJS from "crypto-js";

export default {
  // 加密
  encrypt(word) {
    const key = CryptoJS.enc.Utf8.parse("k%@th8U^BfanlYO@");
    const iv = CryptoJS.enc.Utf8.parse("pgzA8eq4o6tY^q2#");
    const srcs = CryptoJS.enc.Utf8.parse(word);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },
  // 解密
  decrypt(word) {
    const key = CryptoJS.enc.Utf8.parse("k%@th8U^BfanlYO@");
    const iv = CryptoJS.enc.Utf8.parse("pgzA8eq4o6tY^q2#");
    const decrypt = CryptoJS.AES.decrypt(word, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypt.toString(CryptoJS.enc.Utf8);
  }
};
